export const styles = () => ({
  headerBar: {
    borderTop: "1px solid #EEEEEE",
    borderBottom: "1px solid #EEEEEE",
    padding: "0px",
    paddingRight: 20,
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  // styles for no prop view
  root: {
    height: '79vh',
    display: 'flex',
    flexFlow: 'column'
  },
  emptyBox: {
    background: '#FFFFFF',
    border: '1px solid #DADADA',
    boxSizing: 'border-box',
    flex: '1 1 auto',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  NPText: {
    marginTop: 20,
    textAlign: 'center',
    fontSize: 14,
    lineHeight: '24px',
    color: 'rgba(51, 51, 51, 0.75)',
  },
  superContainer: {
    maxHeight: "calc(100vh - 65px)",
    background: "#f9f9f9",
    overflowY: 'auto'
  },
  customRoot: {
    maxHeight: "calc(100vh - 115px)"
  }
})